import type { Story } from '@/store/story-types'

export const CONTENT_HUB_STORY: Story = {
  id: 'content-hub-1',
  name: 'Content Hub',
  narrative: 'A multi-media creator hub showcasing videos and podcast episodes, helping creators centralize their content and grow their audience — inspired by YouTube creators and podcast hosts.',
  goals: ['Showcase creator brand', 'Display latest videos', 'List podcast episodes', 'Drive subscriptions'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Alex Creates', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home', description: 'Hub home with navbar, hero, latest videos, podcast episodes, and footer',
      blockRef: { category: 'content', blockId: 'hub-hero' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Content',
      description: 'Visitor sees the hero and content overview',
      steps: [
        { type: 'given', text: 'the visitor opens the content hub' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the hero section with creator intro and featured content is visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Watch Videos',
      description: 'Visitor browses the latest video section',
      steps: [
        { type: 'given', text: 'the visitor is on the hub homepage' },
        { type: 'when', text: 'they scroll to the latest videos section' },
        { type: 'then', text: 'video cards with thumbnails, titles, and durations are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Listen to Podcasts',
      description: 'Visitor browses podcast episodes',
      steps: [
        { type: 'given', text: 'the visitor is on the hub homepage' },
        { type: 'when', text: 'they scroll to the podcast episodes section' },
        { type: 'then', text: 'episode cards with titles, descriptions, and play buttons are shown', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Subscribe',
      description: 'Visitor subscribes to the content hub',
      steps: [
        { type: 'given', text: 'the visitor wants to follow the creator' },
        { type: 'when', text: 'they click the Subscribe button in the hero' },
        { type: 'then', text: 'a subscription confirmation is shown', linkedFlowId: 'subscribeHub' },
      ],
    },
  ],
}
